import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { LifeBuoy, CalendarCheck, Heart } from 'lucide-react';
import { EASE_OUT } from '../../utils/motion';
const packages = [{
  label: 'Paket 1',
  level: 35
}, {
  label: 'Paket 2',
  level: 55
}, {
  label: 'Paket 3',
  level: 75
}, {
  label: 'Paket 4',
  level: 95
}];
const pulsePath = 'M0 15 H70 L78 4 L88 26 L96 10 L102 15 H200';
export function SupportIllustration() {
  const reduceMotion = useReducedMotion();
  return <div className="absolute inset-0 p-6 xl:p-8 flex flex-col gap-4" data-id="element-143" data-mp="22b6ctn5jz8f4">
      <div className="bg-white rounded-2xl shadow-sm px-5 py-4 flex items-center gap-4" data-id="element-144" data-mp="22dixi82p3wvv">
        <div className="w-12 h-12 rounded-full bg-accent flex items-center justify-center shrink-0" data-id="element-145" data-mp="279806ka0htwe">
          <LifeBuoy className="w-6 h-6 text-primary" data-id="element-146" data-mp="2c7j6il13lm9v" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-147" data-mp="3iowkf3vvseti">
          <p className="text-sm font-semibold text-primary" data-id="element-148" data-mp="3is0v8k3uq8t5">
            Auch nach dem Projekt für Sie da
          </p>
          <svg viewBox="0 0 200 30" className="w-full h-8" preserveAspectRatio="none" data-id="element-149" data-mp="2ev1wr9j9ub4j">
            <path d={pulsePath} fill="none" stroke="#284756" strokeOpacity={0.1} strokeWidth={2} data-id="element-150" data-mp="29w7fwd4v6wn2" />
            <motion.path d={pulsePath} fill="none" stroke="#96c11f" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" initial={{
            pathLength: reduceMotion ? 1 : 0
          }} animate={reduceMotion ? {
            pathLength: 1
          } : {
            pathLength: [0, 1, 1],
            opacity: [1, 1, 0]
          }} transition={{
            duration: 2.4,
            repeat: Infinity,
            ease: 'linear',
            times: [0, 0.8, 1]
          }} data-id="element-151" data-mp="25ulv85m39e2b" />
          </svg>
        </div>
      </div>

      <div className="flex-1 bg-white rounded-2xl shadow-sm p-5 flex flex-col min-h-0" data-id="element-152" data-mp="1d5yfsqo0tiwo">
        <p className="text-sm font-semibold text-primary mb-4" data-id="element-153" data-mp="1d7ss5gl882p5">
          Support-Pakete zur Wahl
        </p>
        <div className="flex-1 grid grid-cols-4 gap-3 min-h-0" data-id="element-154" data-mp="yj9bmbitqhjy">
          {packages.map((p, i) => <div key={p.label} className="h-full flex flex-col justify-end items-center gap-2" data-id="element-155" data-mp="13i2oc1qae4j2" data-mpi={i}>
              <motion.div className="w-full rounded-t-xl bg-primary" style={{
            opacity: 0.4 + i * 0.2
          }} initial={{
            height: 0
          }} animate={{
            height: `${p.level}%`
          }} transition={{
            duration: 0.3,
            ease: EASE_OUT,
            delay: 0.35 + i * 0.06
          }} data-id="element-156" data-mp="olblfihemaop" />
              <span className="text-xs font-semibold text-primary" data-id="element-157" data-mp="1m7sg0fyr6a6r">{p.label}</span>
            </div>)}
        </div>
      </div>

      <div className="flex gap-3" data-id="element-158" data-mp="17huzmm72eos4">
        <span className="bg-white rounded-full px-4 py-2 text-sm font-medium text-primary shadow-sm flex items-center gap-2" data-id="element-159" data-mp="1cir3izrf2axj">
          <Heart className="w-4 h-4 text-accent-dark" data-id="element-160" data-mp="207k110nosqu9" />
          Freiwillig, aber ratsam
        </span>
        <span className="bg-white rounded-full px-4 py-2 text-sm font-medium text-primary shadow-sm flex items-center gap-2" data-id="element-161" data-mp="2503fdzu77q04">
          <CalendarCheck className="w-4 h-4 text-accent-dark" data-id="element-162" data-mp="3pnvzr47efy2o" />
          Jährliche Zahlung
        </span>
      </div>
    </div>;
}